export default __webpack_public_path__ + "static/media/A-graphic-large.f970fef1.svg";